export default class GreedyNav {
  constructor({ navElement, items, itemGap }) {
    this._navElement = navElement;
    this._items = items;
    this._itemGap = itemGap;

    this._spaceContainer = navElement.querySelector(".gnav__primary-container");
    this._primaryMenu = navElement.querySelector(".gnav__primary");
    this._hiddenMenu = navElement.querySelector(".gnav__hidden-menu");
    this._menuButton = navElement.querySelector(".gnav__menu-button");

    // console.log("limit", this._spaceContainer.offsetWidth);

    this._activeItem = null;

    this._totalItemLength = 0;

    this._classes = {
      activeItem: "gnav-item--active",
      hiddenButton: "gnav__menu-button--hide",
      // stagedItem: "gnav-item--staged",
    };

    this._init();
  }

  _init() {
    this._setEventListeners();
    this._defaultOption();
    this._loadItems();
    this._decideShowMenuButton();
  }

  _decideShowMenuButton() {
    if (![...this._hiddenMenu.children].length) {
      console.log("hide menu");
      this._menuButton.classList.add(this._classes.hiddenButton);
    } else {
      console.log("show");
      this._menuButton.classList.remove(this._classes.hiddenButton);
    }
  }

  _setEventListeners() {
    // menu button
    this._menuButton.addEventListener(
      "click",
      this._handleMenuButton.bind(this)
    );

    // window resize
    window.addEventListener("resize", this._handleResize.bind(this));
  }

  _handleResize() {
    // check if current elements do not fit
    this._adjustPrimaryNav();

    // check if hidden element fits
    // if (this._hiddenMenu.childElementCount) {
    //   console.log("checking fit");
    //   const nextElement = this._hiddenMenu.firstElementChild;
    //   this._appendNavItem(nextElement);
    // }
  }

  _adjustPrimaryNav() {
    if (this._totalItemLength > this._spaceContainer.offsetWidth) {
      this._moveToHiddenMenu(this._primaryMenu.lastChild);
      this._adjustPrimaryNav();
    }

    if (
      this._totalItemLength < this._spaceContainer.offsetWidth &&
      this._hiddenMenu.firstElementChild
    ) {
      this._appendNavItem(this._hiddenMenu.lastElementChild);
    }

    this._decideShowMenuButton();
  }

  _moveToHiddenMenu(navItem) {
    this._totalItemLength = this._totalItemLength - this._getItemWidth(navItem);
    navItem.remove();
    this._hiddenMenu.append(navItem);
  }

  _defaultOption() {
    const defaultOption = {
      name: "All",
      link: "/blog",
      isCurrent: true,
    };

    this._defaultNavItem = this._createNavItem(defaultOption);

    // this._appendActiveItem(this._defaultNavItem, true);

    this._appendNavItem(this._defaultNavItem);
    // this._primaryMenu.prepend(defaultNavItem);
  }

  _loadItems() {
    // handle active item first if there is one
    const activeItem = this._items.find((item) => item.isCurrent);

    if (activeItem) {
      const navItem = this._createNavItem(activeItem);
      this._insertActiveItem(navItem);
      this._deactivateItem(this._defaultNavItem);
      this._activeItem = navItem;
    }

    this._items.forEach((itemData) => {
      if (itemData.isCurrent) return;
      const navItem = this._createNavItem(itemData);
      // if (itemData.isCurrent) {
      //   if (this._defaultNavItem) {
      //     this._deactivateItem(this._defaultNavItem);
      //   }
      //   // this._appendActiveItem(navItem);
      // }
      // this._appendNavItem(navItem);
      this._appendNavItem(navItem);
      // setTimeout(() => {
      //   console.log(navItem, navItem.offsetWidth);
      // }, 0);
    });
  }

  // _appendActiveItem(navItem, isDefault) {
  //   isDefault = isDefault || false;
  //   this._totalItemLength = this._getItemWidth(navItem) + this._totalItemLength;

  //   // if (!isDefault) {
  //   //   this._defaultNavItem.parentNode.insertBefore(
  //   //     navItem,
  //   //     this._defaultNavItem.nextSibling
  //   //   );
  //   //   // this._adjustPrimaryNav();
  //   // }
  // }

  _insertActiveItem(navItem) {
    this._defaultNavItem.after(navItem);
    const newTotalItemLength =
      this._getItemWidth(navItem) + this._totalItemLength;
    this._totalItemLength = newTotalItemLength;
  }

  _appendNavItem(navItem) {
    console.log("ran", navItem);
    // if (active) {
    //   this._insertActiveItem(navItem);
    //   return;
    // }
    this._primaryMenu.append(navItem);
    const newTotalItemLength =
      this._getItemWidth(navItem) + this._totalItemLength;
    if (!this._fitsPrimary(newTotalItemLength)) {
      navItem.remove();
      return this._hiddenMenu.append(navItem);
    }
    this._totalItemLength = newTotalItemLength;
    console.log(navItem, this._totalItemLength);
  }

  _getItemWidth(navItem) {
    return navItem.offsetWidth + this._itemGap;
  }

  _fitsPrimary(newTotalItemLength) {
    return (
      newTotalItemLength <= this._spaceContainer.offsetWidth - this._itemGap
    );
    // console.log("newTotalItemLength", newTotalItemLength);
    // if (newTotalItemLength <= this._primaryMenu.offsetWidth) {
    //   console.log("fits", navItem);
    //   // item fits
    //   this._totalItemLength = newTotalItemLength;
    //   return true;
    // }
    // console.log("no fit", navItem);
    // return false;
  }

  _deactivateItem(navItem) {
    navItem.classList.remove(this._classes.activeItem);
  }

  _createNavItem({ name, link, isCurrent }) {
    const li = document.createElement("li");

    li.className = "gnav-item";

    if (isCurrent) {
      li.classList.add(this._classes.activeItem);
      // deactivate default nav item
      // if (this._defaultNavItem) {
      //   this._deactivateItem(this._defaultNavItem);
      // }
      // this._activeItem = li;
    }

    const a = document.createElement("a");
    a.href = link;
    a.className = "gnav-item__link";
    a.textContent = name;

    li.append(a);

    return li;
  }

  _handleMenuButton(e) {
    this._hiddenMenu.classList.toggle("gnav__hidden-menu--open");
  }
}
